const state = {
    ticketingQueueObj:null,
    filterSearchObj:null,
    orderId:null,
    isBooking:null,
   flightInfo:null

};

const getters = {
    GET_TICKETING_QUEUE: (state) => {
        return state.ticketingQueueObj;
    },
    GET_FILTER_SEARCH_OBJ: (state) => {
        return state.filterSearchObj;
    },
    GET_ORDER_ID: (state) => {
        return state.orderId;
    },
    GET_IS_BOOKING_STATUS: (state) => {
        return state.isBooking;
    },
    GET_FLIGHT_INFO: (state) => {
        return state.flightInfo;
    }


};


const actions = {

    CLEAR_TICKETING_QUEUE_STORE: ({ commit }) => {
        commit('clearTicketingQueueStore');
    },

    SET_IS_BOOKING_STATUS: ({ commit }, isBooking) => {
        commit('saveisbookingstatus', isBooking);
    },

    ///to check for the status of pax in refund/exchange
    SET_FLIGHT_INFO_STATUS: ({ commit }, flightInfo) => {
        commit('saveFlightInfo', flightInfo);
    },

    
   ///single ticketing queue object
    SET_TICK_QUEUE_REQ: ({ commit }, req) => {

        commit('saveTickQueueReq', req);

    },

    SET_FILTER_SEARCH_OBJ: ({ commit }, req) => {

        commit('saveFilterSearchObj', req);

    },

    SET_ORDER_ID: ({ commit }, orderId) => {
        commit('saveOrderId',orderId);
    }

};


const mutations = {
    clearTicketingQueueStore: (state) => {
     
        state.ticketingQueueObj = null;
        state.filterSearchObj = null;


    },

    saveFlightInfo: (state, flightInfo) => {
        state.flightInfo = flightInfo;
    },

    saveisbookingstatus: (state, isBooking) => {
        state.isBooking = isBooking;
    },
   
    saveTickQueueReq: (state, req) => {
        state.ticketingQueueObj = req;
    },
    saveFilterSearchObj: (state, req) => {
        state.filterSearchObj = req;
    },
   saveOrderId: (state, orderId) => {
       state.orderId = orderId;
   }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}